<template>
  <div class="home">
    <!--
    <Slide />
    <Product />
    <Secure />
    -->
    <HomeHero />
    <News />
    <HomeFooter />
  </div>
</template>

<script>
import Slide from "./components/slide";
import Product from "./components/product";
import Secure from "./components/secure";
import HomeHero from "./components/homeHero";
import News from "./components/news";
import HomeFooter from "./components/footer";
export default {
  name: "HomePage",
  components: {
    // 旧首页模块暂不展示，保留注册以便恢复时直接取消模板注释。
    Slide,
    Product,
    Secure,
    HomeHero,
    News,
    HomeFooter
  }
};
</script>

<style lang="scss" scoped>

</style>
